<template>
  <div class="editable-cell">
    <div class="editable-cell-input-wrapper">
      <a-input placeholder="请输入列宽" :value="value" @blur="onBlur" @change="handleChange" @pressEnter="check" />
      <!-- <a-icon
        type="check"
        class="editable-cell-icon-check"
        @click="check"
      /> -->
    </div>
    <!-- <div v-else class="editable-cell-text-wrapper">
      {{ value || ' ' }}
      <a-icon type="edit" class="editable-cell-icon" @click="edit" />
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: true,
    };
  },
  watch: {
    text() {
      if(this.text) {
        this.value = this.text
      }
    }
  },
  methods: {
    handleChange(e) {
      const { value } = e.target;
      const reg = /^-?[0-9]*(\.[0-9]*)?$/;
      if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
        this.value = value;
        this.value = value;
      }
      
      // const value = e.target.value;
    },
    onBlur() {
      const { value, onChange } = this;
      let valueTemp = value;
      if (value.charAt(value.length - 1) === '.' || value === '-') {
        onChange({ value: value.slice(0, -1) });
      }
      this.$emit('change', this.value);
    },
    check() {
      this.editable = false;
      this.$emit('change', this.value);
    },
    edit() {
      this.editable = true;
    },
  },
};
/* export const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String,
  },
  data() {
    return {
      value: this.text,
      editable: false,
    };
  },
  methods: {
    handleChange(e) {
      const value = e.target.value;
      this.value = value;
    },
    check() {
      this.editable = false;
      this.$emit('change', this.value);
    },
    edit() {
      this.editable = true;
    },
  },
}; */

</script>
<style lang="less" scoped>
.editable-cell-input-wrapper{
  display: flex;
  align-items: center;
  justify-content: space-around;
}
  
</style>